var ANDROID = 1;
var IOS = 2;
var jsBridge = /** @class */ (function () {
    function jsBridge(bridgeName, bridgeScheme) {
        this.curApp = 1;
        this.bridgeName = "";
        this.bridgeScheme = "";
        var ua = window.navigator.userAgent.toLocaleLowerCase();
        if (/android/.test(ua)) {
            this.curApp = ANDROID;
            this.initAndroidOperator();
        }
        else if (/(iphone|ipad|ipod|ios)/.test(ua)) {
            this.curApp = IOS;
            this.initIOSOperator(bridgeName, bridgeScheme);
        }
    }
    /* 获取 bridge */
    jsBridge.prototype.IOS_getBridge = function (callback) {
        var win = window;
        if (win[this.bridgeName]) {
            callback(win[this.bridgeName]);
            return;
        }
        // WebViewJavascriptBridge 由native在注入  
        // https://github.com/marcuswestin/WebViewJavascriptBridge
        if (window.WVJBCallbacks) {
            return window.WVJBCallbacks.push(callback);
        }
        window.WVJBCallbacks = [callback];
        var WVJBIframe = document.createElement('iframe');
        WVJBIframe.style.display = 'none';
        WVJBIframe.src = 'https://__bridge_loaded__';
        document.documentElement.appendChild(WVJBIframe);
        setTimeout(function () {
            document.documentElement.removeChild(WVJBIframe);
        }, 0);
    };
    /**
     * 给ios和android注册事件监听
     *
     * @memberof jsBridge
     */
    jsBridge.prototype.IOS_on = function (event, jsHandler) {
        this.IOS_registHandler(event, jsHandler);
    };
    /**
     * 默认监听事件
     *
     * @memberof jsBridge
     */
    jsBridge.prototype.IOS_registDefaultHandlerForApp = function () {
        this.IOS_on('reload', function () {
            location.reload();
        });
    };
    /**
     * 注册事件逻辑
     *
     * @memberof jsBridge
     */
    jsBridge.prototype.IOS_registHandler = function (event, jsHandler) {
        this.IOS_getBridge(function (bridge) {
            if (bridge && bridge.registerHandler && typeof bridge.registerHandler === "function") {
                bridge.registerHandler(event, function (data2js, responseCallback) {
                    responseCallback = responseCallback || function () { };
                    jsHandler(data2js, responseCallback);
                });
            }
        });
    };
    /**
     * 调用 app
     * @param {string} event
     * @param {object} params
     * @param {fun} callback
     * @return JSON对象
     */
    jsBridge.prototype.IOS_callHandler = function (event, params, callback) {
        return this.IOS_getBridge(function (bridge) {
            if (bridge && bridge.registerHandler && typeof bridge.registerHandler === "function") {
                bridge.callHandler(event, params, callback);
            }
        });
    };
    jsBridge.prototype.initIOSOperator = function (bridgeName, bridgeScheme) {
        this.bridgeName = bridgeName || 'WebViewJavascriptBridge';
        this.bridgeScheme = bridgeScheme || 'https';
        this.IOS_registDefaultHandlerForApp();
    };
    //default:this,
    jsBridge.prototype.Android_call = function (b, a, c) {
        var e = "";
        "function" == typeof a && (c = a, a = {});
        a = {
            data: void 0 === a ? null : a
        };
        var win = window;
        if ("function" == typeof c) {
            var g = "dscb" + window.dscb++;
            win[g] = c;
            a._dscbstub = g;
        }
        a = JSON.stringify(a);
        if (c) {
            //document.write("window._dsbridge=>", window._dsbridge.call(b, a));
            // document.write(b, ",", a, ",", c, ",", String(window.dscb));
        }
        if (window._dsbridge)
            e = window._dsbridge.call(b, a);
        else if (window._dswk || -1 != navigator.userAgent.indexOf("_dsbridge"))
            e = prompt("_dsbridge=" + b, a);
        return JSON.parse(e || "{}").data;
    };
    jsBridge.prototype.Android_register = function (b, a, c) {
        var _this = this;
        c = c ? window._dsaf : window._dsf;
        if (!window._dsInit) {
            window._dsInit = true;
            setTimeout(function () {
                _this.Android_call("_dsb.dsinit");
            }, 0);
        }
        if ("object" == typeof a) {
            c._obs[b] = a;
        }
        else {
            c[b] = a;
        }
    };
    jsBridge.prototype.Android_registerAsyn = function (b, a) {
        this.Android_register(b, a, !0);
    };
    jsBridge.prototype.Android_hasNativeMethod = function (b, a) {
        return this.Android_call("_dsb.hasNativeMethod", {
            name: b,
            type: a || "all"
        });
    };
    jsBridge.prototype.Android_disableJavascriptDialogBlock = function (b) {
        this.Android_call("_dsb.disableJavascriptDialogBlock", {
            disable: !1 !== b
        });
    };
    jsBridge.prototype.Android_close = function () {
        this.Android_call("_dsb.closePage");
    };
    jsBridge.prototype.initAndroidOperator = function () {
        if (!window._dsf) {
            var b = {
                _dsf: {
                    _obs: {}
                },
                _dsaf: {
                    _obs: {}
                },
                dscb: 0,
                dsBridge: {
                    call: this.Android_call,
                    register: this.Android_register,
                    registerAsyn: this.Android_registerAsyn,
                    hasNativeMethod: this.Android_hasNativeMethod,
                    disableJavascriptDialogBlock: this.Android_disableJavascriptDialogBlock
                },
                _handleMessageFromNative: function (a) {
                    var _this = this;
                    var e = JSON.parse(a.data), b = {
                        id: a.callbackId,
                        complete: !0
                    }, c = this._dsf[a.method], d = this._dsaf[a.method], h = function (a, c) {
                        b.data = a.apply(c, e);
                        _this.Android_call("_dsb.returnValue", b);
                    }, k = function (a, c) {
                        e.push(function (a, c) {
                            b.data = a;
                            b.complete = !1 !== c;
                            _this.Android_call("_dsb.returnValue", b);
                        });
                        a.apply(c, e);
                    };
                    if (c)
                        h(c, this._dsf);
                    else if (d)
                        k(d, this._dsaf);
                    else if (c = a.method.split("."), !(2 > c.length)) {
                        a = c.pop();
                        var c = c.join("."), d = this._dsf._obs, d = d[c] || {}, f = d[a];
                        f && "function" == typeof f ? h(f, d) : (d = this._dsaf._obs, d = d[c] || {},
                            (f = d[a]) && "function" == typeof f && k(f, d));
                    }
                }
            }, a = void 0;
            var win = window;
            for (a in b) {
                win[a] = b[a];
            }
            this.Android_register("_hasJavascriptMethod", function (a, b) {
                b = a.split(".");
                if (2 > b.length)
                    return !(!b._dsf[b] && !window._dsaf[b]);
                a = b.pop();
                b = b.join(".");
                return (b = window._dsf._obs[b] || b._dsaf._obs[b]) && !!b[a];
            });
        }
    };
    return jsBridge;
}());
export default jsBridge;
//# sourceMappingURL=jsbridge.js.map